import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar.jsx';
import Topbar from './Topbar.jsx';
import ConnectaWidget from '../components/ConnectaWidget.jsx';
import { useScrollMemory } from '../lib/useScrollMemory.js';

/**
 * Shell da aplicação: Sidebar + Topbar + área de conteúdo (Outlet).
 * - `mobileOpen`: drawer da sidebar em telas pequenas.
 * - `collapsed`: modo rail (ícones) em telas grandes, persistido.
 */
export default function MainLayout() {
  useScrollMemory();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem('feed_sidebar_collapsed') === '1'
  );

  const toggleCollapse = () => {
    setCollapsed((v) => {
      const next = !v;
      localStorage.setItem('feed_sidebar_collapsed', next ? '1' : '0');
      return next;
    });
  };

  return (
    // h-dvh: fixa ao viewport real (mobile considera barra do browser).
    // overflow-hidden: garante que o scroll aconteça dentro de main, não no documento.
    <div className="h-dvh bg-bg overflow-hidden">
      <Sidebar
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        collapsed={collapsed}
        onToggleCollapse={toggleCollapse}
      />

      {/* Conteúdo deslocado pela largura da sidebar (apenas desktop). */}
      <div
        className={[
          'flex flex-col h-full transition-all duration-300 ease-out',
          collapsed ? 'lg:pl-[76px]' : 'lg:pl-64',
        ].join(' ')}
      >
        <Topbar onOpenMenu={() => setMobileOpen(true)} />
        {/* overflow-y-auto: scrollport do conteúdo — funciona em iOS/Android via touch. */}
        <main id="main-scroll" className="flex-1 overflow-y-auto overscroll-y-contain p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>

      <ConnectaWidget />
    </div>
  );
}
